import Channels from './';
export default [
  {
    type: 'private',
    path: '/channels',
    component: Channels,
    exact: true,
    private: true
  }
];



// WEBPACK FOOTER //
// ./src/views/channels/_routes.js